module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-indoor-582.27a0b3efe00405e7.png"+" 582w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-indoor-582.27a0b3efe00405e7.png",width: 582,height: 400}],
        src: "https://static.sniffspot.com/packs/img/dog-indoor-582.27a0b3efe00405e7.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-indoor-582.27a0b3efe00405e7.png"},
        
        width: 582,
        height: 400
      }